import { RequestMethod } from 'lib/api-types';
import { baseApiUrl } from 'redux/reducers/settings';

const baseUrl = baseApiUrl;

export const userApi = {
  // Existing API
  traineePersonalDetail: {
    actionName: 'UPDATE_PERSONAL_DETAILS',
    controllerName: `${baseUrl}users/trainee/{traineeId}/personal-details/`,
    requestMethod: RequestMethod.GET
  },

  fetchUserProfile: {
    actionName: 'FETCH_USER_PROFILE',
    controllerName: `${baseUrl}users/admin/detail/{id}/`,
    requestMethod: RequestMethod.GET
  },
  getGalleryByRoutineId: {
    actionName: 'FETCH_GALLERY_BY_ROUTINE_ID',
    controllerName: `${baseUrl}reports/gallery/routine/{routineId}`,
    requestMethod: RequestMethod.GET
  },
  getTraineeEthnicitySummary: {
    actionName: 'FETCH_TRAINEE_ETHNICITY_SUMMARY',
    controllerName: `${baseUrl}reports/trainee-ethnicity-summary`,
    requestMethod: RequestMethod.GET
  },
  getTraineeGenderSummary: {
    actionName: 'FETCH_TRAINEE_GENDER_SUMMARY',
    controllerName: `${baseUrl}reports/trainee-gender-summary`,
    requestMethod: RequestMethod.GET
  },
  getTraineeTrainingHistory: {
    actionName: 'FETCH_TRAINEE_TRAINING_HISTORY',
    controllerName: `${baseUrl}reports/trainee-training-history`,
    requestMethod: RequestMethod.GET
  },
  getTrainingList: {
    actionName: 'FETCH_TRAINING_LIST',
    controllerName: `${baseUrl}reports/trainings`,
    requestMethod: RequestMethod.GET
  },
  getTrainingDetail: {
    actionName: 'FETCH_TRAINING_DETAIL',
    controllerName: `${baseUrl}reports/training/{trainingId}/trainees`,
    requestMethod: RequestMethod.GET
  },

  getUserActiveTraining: {
    actionName: 'USER_ACTIVE_TRAINING_DETAIL',
    controllerName: `${baseUrl}users/admin/routines/active`,
    requestMethod: RequestMethod.GET
  }
}